// extracted by mini-css-extract-plugin
export default {"wrapper":"AddDocumentButton_wrapper__7pBfM","active":"AddDocumentButton_active__KxfYC"};